import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Button } from "react-bootstrap";
import loop from "../../assets/svg/loop.svg";
import calender from "../../assets/svg/calender.svg";
import cross from "../../assets/svg/cross.svg";
import { apiCall } from '../../services/api-service';
import { useNavigate } from "react-router-dom";
import moment from "moment";
//repeat every 1 days

//repeat week days only

//repeat every 2 weeks on s,m,t

//repeat every __ month on first monday

//repeat every __ month on day 1






const RepeatBookingModal = ({ roomId, show, onHide }) => {
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [slotAvailable, setSlotAvailable] = useState(false);
    const [repeatPayload, setRepeatPayload] = useState(false);
    const [selectedRepeatType, setRepeatType] = useState("daily");
    const [everyDayOnce, setEveryDayOnce] = useState(1); // Common for all daily, weekly, monthly
    const [selectedDaysOption, setSelectedDaysOption] = useState("");
    const [selectedMonthOption, setSelectedMonthOption] = useState(""); // onDay, position
    const [dayOfMonth, setDayOfMonth] = useState(1);
    const [selectedMonthlyPositionOption, setSelectedMonthlyPositionOption] = useState(""); // First, Second, Third, Fourth, Last
    const [selectedPositionDayOption, setSelectedPositionDayOption] = useState("");// Sun, Mon, Tue, Wed, ...

    const [selectedDays, setSelectedDays] = useState([]);

    const days = ["S", "M", "T", "W", "T", "F", "S"];


    const handleRadioChange = (day) => {
        setSelectedDays((prev) => ({
            ...prev,
            [day]: true, // Mark only the selected radio button
        }));
    };


    const [daily, setDaily] = useState(""); // Stores values of name="di"
    const [weekly, setWeekly] = useState(""); // Stores values of name="wi"
    const [monthly, setMonthly] = useState(""); // Stores values of name="mi"

    const handleChange = (event) => {
        const { name, value } = event.target;

        if (name === "di") {
            setDaily(value);
        } else if (name === "wi") {
            setWeekly(value);
        } else if (name === "mi1") {
            setMonthly(value);
        }
    };


    const toggleDaySelection = (index) => {
        setSelectedDays((prevSelected) =>
            prevSelected.includes(index)
                ? prevSelected.filter((day) => day !== index)
                : [...prevSelected, index]
        );
    };
    useEffect(() => {
        repeatPayloadObject()
    }, []);
    useEffect(() => {
        repeatPayloadObject()
    }, [selectedRepeatType, everyDayOnce, selectedDaysOption, selectedMonthOption, dayOfMonth, daily,]);

    const buildRepeatPayload = () => {
        const payload = {
            start_date: document.getElementById("start_date").value,
            end_date: document.getElementById("end_date").value,
            repeat: everyDayOnce,
        };

        if (selectedRepeatType === 'daily') {
            payload.recurrence_type = selectedRepeatType;
            payload.repeat_on = {
                week_days_only: selectedDaysOption === "weekDays",
                days_of_week: [],
            };
        }

        if (selectedRepeatType === 'weekly') {
            const fullDays = selectedDays.map((day) => {
                if (day === 0) return "sunday";
                if (day === 1) return "monday";
                if (day === 2) return "tuesday";
                if (day === 3) return "wednesday";
                if (day === 4) return "thursday";
                if (day === 5) return "friday";
                if (day === 6) return "saturday";
                return "";
            });
            payload.recurrence_type = selectedRepeatType;
            payload.repeat_on = {
                week_days_only: false,
                days_of_week: fullDays,
            };
        }

        if (selectedRepeatType === 'monthly') {
            if (selectedMonthOption === "onDay") {
                payload.recurrence_type = "monthly_fixed";
                payload.repeat_on = {
                    day_of_month: dayOfMonth,
                    day: "",
                    position: "",
                    week_days_only: false,
                    days_of_week: [],
                };
            }
            if (selectedMonthOption === "position") {
                payload.recurrence_type = "monthly_relative";
                payload.repeat_on = {
                    day_of_month: dayOfMonth,
                    position: document.getElementById("position").value,
                    day: document.getElementById("position_day").value,
                    week_days_only: false,
                    days_of_week: [],
                };
            }
        }

        return {
            date: "",
            room_id: roomId,
            from: document.getElementById("from_time").value,
            to: document.getElementById("to_time").value,
            repeat_booking: true,
            repeat: payload,
        };
    };

    const repeatPayloadObject = () => {
        const finalPayload = buildRepeatPayload();
        setRepeatPayload(finalPayload);
    }

    const checkAvailability = async () => {
        setSlotAvailable(false);
        setErrorMessage('');
        try {
            const finalPayload = buildRepeatPayload();
            setRepeatPayload(finalPayload);
            const response = await apiCall("post", "check_slot_availability", finalPayload);
            if (response?.status === 400 || response?.status === 422) {
                const errorMsg = response.data?.error;
                setSlotAvailable(false);
                if (errorMsg && typeof errorMsg === 'object') {
                    const messages = Object.values(errorMsg).flat().join(', ');
                    setErrorMessage(messages || response.data?.message || 'Validation error');
                } else {
                    setErrorMessage(response.data?.message || 'Invalid booking parameters provided');
                }
            } else if (response?.data?.success === true) {
                if (response.data.available === true) {
                    setSlotAvailable(true);
                    setErrorMessage('');
                } else {
                    setSlotAvailable(false);
                    setErrorMessage('Selected slot is already booked for the specified dates.');
                }
            } else {
                setSlotAvailable(false);
                setErrorMessage(response?.data?.message || 'Unable to check slot availability.');
            }

        } catch (err) {
            console.error("Error fetching options:", err);
            /*  setError("Failed to fetch options. Try again."); */
        } finally {
            /*  setLoading(false); */
        }

    };
    function commonFormatDate(inputDate, formatString) {
        try {
            if (inputDate !== undefined) {
                /* // Parse the input date (MM/DD/YYYY format)
                const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());
        
                // Format the date
                return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
                return moment(inputDate).format(formatString)
            } else {
                return "";
            }
        } catch (err) {
            console.error("Error fetching options:", err);
        } finally {
        }
    }
    const convertTo12HourFormat = (time) => {
        let [hours, minutes] = time.split(":");
        let period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${hours}:${minutes} ${period}`;
    };
    const repeatSentence = () => {
        if (repeatPayload.repeat?.recurrence_type === "daily") {
            if (repeatPayload.repeat.repeat_on.week_days_only === true) {
                return "The booking will repeat week days from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "."
            }
            return "The booking will repeat every " + repeatPayload.repeat.repeat + " day(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "."
        } else if (repeatPayload.repeat?.recurrence_type === "weekly") {
            return "The meeting will repeat every " + repeatPayload.repeat.repeat + " week(s) once from " + repeatPayload.repeat.repeat_on.days_of_week.join(",") + " from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "";
        } else if (repeatPayload.repeat?.recurrence_type === "monthly_fixed") {
            return "The meeting will repeat on the " + repeatPayload.repeat.day_of_month + " of every " + repeatPayload.repeat.repeat + " month(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "";
        } else if (repeatPayload.repeat?.recurrence_type === "monthly_relative") {
            return "The meeting will repeat on the " + repeatPayload.repeat.repeat_on.position + " " + repeatPayload.repeat.repeat_on.day + " of every " + repeatPayload.repeat.repeat + " month(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "";
        } else {
            return ""
        }
    }
    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Body className="GTWalsheimTrial px-3 py-3" style={{ backgroundColor: '#FFFFFF', borderRadius: '24px', }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div style={{ fontWeight: '700', fontSize: '20px', color: '#1E1E1E' }}>
                        Repeat
                    </div>
                    <button onClick={onHide} style={{ border: 'none', backgroundColor: '#FFFFFF' }}>
                        <img src={cross} />
                    </button>

                </div>

                <div style={{ width: '100%' }}>
                    <select value={selectedRepeatType} style={{ width: '100%', border: '3px solid #FFE0E6', borderRadius: '10px', fontSize: '15px', fontWeight: '500', color: '#1E1E1E' }} className="px-2 py-2" onChange={(e) => setRepeatType(e.target.value)}>
                        <option value="daily">Repeat daily</option>
                        <option value="weekly">Repeat weekly</option>
                        <option value="monthly">Repeat monthly</option>
                    </select>

                    {selectedRepeatType === "daily" && (
                        <div className="d-flex flex-column mb-2 mt-4" style={{ gap: '6px' }}>
                            <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                    <input type="radio" name="dailyDayOption" value="everyDays" checked={selectedDaysOption === "everyDays"} onChange={(event) => { console.log("dailyDayOption day", event.target.value); setSelectedDaysOption(event.target.value); }} style={{ width: '18px', height: '18px' }} />
                                    <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>Every</label>
                                </div>

                                <div>
                                    <input type="number" value={everyDayOnce} onChange={(event) => { setEveryDayOnce(event.target.value); }} name="di" min={1} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', width: '40px', height: '34px', border: 'none', textAlign: "center", fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} />
                                </div>

                                <div style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>
                                    day(s) once
                                </div>

                            </div>

                            <div className="d-flex align-items-center mt-2 mb-4" style={{ gap: '12px' }}>
                                <input type="radio" name="dailyDayOption" value="weekDays" checked={selectedDaysOption === "weekDays"} onChange={(event) => { console.log("dailyDayOption week", event.target.value); setSelectedDaysOption(event.target.value); }} style={{ width: '18px', height: '18px' }} />
                                <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>Week days only</label>
                            </div>

                        </div>
                    )}
                    {selectedRepeatType === "weekly" && (
                        <div className="d-flex flex-column mb-2 mt-4" style={{ gap: '6px' }}>
                            <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                    <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>Every</label>
                                </div>

                                <div>
                                    <input type="text" name="wi" defaultValue="1" style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', width: '34px', height: '34px', border: 'none', textAlign: "center", fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} />
                                </div>

                                <div style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>
                                    week(s) once
                                </div>

                            </div>

                            <div className="d-flex align-items-center mt-2 mb-4" style={{ gap: "8px" }}>
                                {days.map((day, index) => (
                                    <div
                                        key={index}
                                        onClick={() => toggleDaySelection(index)}
                                        style={{
                                            borderRadius: "100px",
                                            width: "40px",
                                            height: "40px",
                                            backgroundColor: selectedDays.includes(index) ? "#842234" : "#FFFFFF",
                                            color: selectedDays.includes(index) ? "#FFFFFF" : "#1E1E1E",
                                            border: "1px solid #E5E5E5",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                            cursor: "pointer",
                                        }}
                                        className="px-3 py-3 d-flex justify-content-center align-items-center"
                                    >
                                        {day}
                                    </div>
                                ))}
                            </div>

                        </div>
                    )}
                    {selectedRepeatType === "monthly" && (
                        <div className="d-flex flex-column mb-2 mt-4" style={{ gap: '6px' }}>
                            <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                    <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>Every</label>
                                </div>

                                <div>
                                    <input type="text" defaultValue="1" name="mi1" style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', width: '34px', height: '34px', border: 'none', textAlign: "center", fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} />
                                </div>

                                <div style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>
                                    month(s) once
                                </div>



                            </div>

                            <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                    <input type="radio" name="mon" value="onDay" checked={selectedMonthOption === "onDay"} onChange={(event) => { setSelectedMonthOption(event.target.value); }} style={{ width: '18px', height: '18px' }} />
                                    <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>On day</label>
                                </div>

                                <div className="mb-2">
                                    <input type="number" value={dayOfMonth} onChange={(event) => { setDayOfMonth(event.target.value); }} name="mi2" style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', width: '40px', height: '34px', border: 'none', textAlign: "center", fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} />
                                </div>

                                <div style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }} className="mb-2">
                                    day(s) once
                                </div>

                            </div>

                            <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                    <input type="radio" name="mon" value="position" checked={selectedMonthOption === "position"} onChange={(event) => { setSelectedMonthOption(event.target.value); }} style={{ width: '18px', height: '18px' }} />
                                    <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>On the</label>
                                </div>

                                <div>
                                    <select id="position" onChange={() => { repeatPayloadObject() }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', border: 'none' }} className="px-2 py-2" >
                                        <option value="">Select</option>
                                        <option value="first">First</option>
                                        <option value="second">Second</option>
                                        <option value="third">Third</option>
                                        <option value="fourth">Fourth</option>
                                        <option value="last">Last</option>
                                    </select>
                                </div>

                                <div >
                                    <select id="position_day" onChange={() => { repeatPayloadObject() }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', border: 'none' }} className="px-2 py-2" >
                                        <option>Select</option>
                                        <option value="sunday">Sunday</option>
                                        <option value="monday">Monday</option>
                                        <option value="tuesday">Tuesday</option>
                                        <option value="wednesday">Wednesday</option>
                                        <option value="thursday">Thursday</option>
                                        <option value="friday">Friday</option>
                                        <option value="saturday">Saturday</option>
                                    </select>
                                </div>

                            </div>





                        </div>
                    )}


                </div>

                <div className="d-flex flex-column mb-3" style={{ gap: '16px' }}>
                    <div style={{ fontWeight: '800', fontSize: '16px', color: '#1E1E1E' }}>
                        Date
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="col-5">
                            <input type="date" id="start_date" onChange={() => { repeatPayloadObject() }} style={{ width: '100%', border: '1px solid #E5E5E5', borderRadius: '10px', fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} className="px-2 py-2" defaultValue={new Date().toISOString().split("T")[0]} />
                        </div>

                        <div className="col-2 d-flex justify-content-center align-items-center">

                            <div>
                                -
                            </div>

                        </div>

                        <div className="col-5">
                            <input type="date" id="end_date" onChange={() => { repeatPayloadObject() }} style={{ width: '100%', border: '1px solid #E5E5E5', borderRadius: '10px', fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} className="px-2 py-2" defaultValue={new Date(Date.now() + 86400000).toISOString().split("T")[0]} />
                        </div>


                    </div>

                </div>

                <div className="d-flex flex-column mb-4" style={{ gap: '16px' }}>
                    <div style={{ fontWeight: '800', fontSize: '16px', color: '#1E1E1E' }}>
                        Time
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="col-5">
                            <input type="time" id="from_time" onChange={() => { repeatPayloadObject() }} style={{ width: '100%', border: '1px solid #E5E5E5', borderRadius: '10px', fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} className="px-2 py-2" defaultValue={new Date().toTimeString().slice(0, 5)} />
                        </div>

                        <div className="col-2 d-flex justify-content-center align-items-center">

                            <div>
                                -
                            </div>

                        </div>

                        <div className="col-5">
                            <input type="time" id="to_time" onChange={() => { repeatPayloadObject() }} style={{ width: '100%', border: '1px solid #E5E5E5', borderRadius: '10px', fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} className="px-2 py-2" defaultValue={(() => { const date = new Date(); date.setHours(date.getHours() + 1); return date.toTimeString().slice(0, 5); })()} />
                        </div>


                    </div>

                </div>

                <div className="px-3 py-3 d-flex align-items-center" style={{ borderRadius: '8px', backgroundColor: '#FFECF0', gap: '8px' }}>
                    <img src={loop} style={{ width: '16px', height: '16px' }} />
                    <div style={{ fontWeight: '500', fontSize: '14px', color: '#1E1E1E' }}>
                        {/* Repeats every 1 day */}{repeatSentence()}
                    </div>

                </div>

                {errorMessage !== null && errorMessage !== "" && (<div style={{ fontSize: "14px", fontWeight: "700", color: '#FF4444' }}> {errorMessage}  </div>)}


                <div className="d-flex col-12 mt-5 justify-content-end">


                    <button onClick={onHide} className=" px-3 py-2" style={{ borderRadius: '100px', border: '0.6px solid #E5E5E5', backgroundColor: '#FFFFFF', fontWeight: '700', fontSize: '14px' }} >
                        Cancel
                    </button>



                    <button onClick={() => { checkAvailability() }} className="mx-2 px-3 py-2" style={{ borderRadius: '100px', border: '0.6px solid #E5E5E5', backgroundColor: '#842234', color: '#FFFFFF', fontWeight: '700', fontSize: '14px' }} >
                        Check Availability
                    </button>

                    {slotAvailable === true && (<button onClick={() => {

                        navigate("/book-meeting", { state: { id: roomId, repeat_booking: true, repeat: repeatPayload } });

                    }} className="px-3 py-2" style={{ borderRadius: '100px', border: '0.6px solid #E5E5E5', backgroundColor: '#842234', color: '#FFFFFF', fontWeight: '700', fontSize: '14px' }} >
                        Book Slot
                    </button>)}

                </div>




            </Modal.Body>

        </Modal>


    );
};

export default RepeatBookingModal;